module.exports = __webpack_public_path__ + "media/assets/images/directgata-img-e5a4488af7108bc01ae7ac3f30aa9c10.png";